// extracted by mini-css-extract-plugin
export default {"techIcon":"techIcon_techIcon__S+7Sy","techIconWithName":"techIcon_techIconWithName__UeifC","techNameDisplay":"techIcon_techNameDisplay__Wf3U5"};